import { z } from 'zod';

export type Address = z.infer<typeof addressSchema>;
export const addressSchema = z.object({
  label: z.string(),
  latitude: z.number(),
  longitude: z.number(),
});
